// front/src/services/TicketServices/TicketServices.js
import instance from "../../api/Api";

/**
 * @param {object|FormData} data object subject , message ,attachment priority , unitary and status (+ client_request_id)
 * @returns ticket created
 */
export const create_ticket = (data) => {
  return instance.post("/v1/tickets/", data);
};

/**
 * @param {object} params query params for list
 *  - start_date: YYYY-MM-DD
 *  - end_date: YYYY-MM-DD
 *  - status: "pending" or "pending,answered"
 *  - priority: "low" or "low,medium"
 *  - unitary: "support" ...
 *  - search: text
 *  - ordering: "id" | "-id" | "created_at" | "-created_at" | "updated_at" | "-updated_at" | "last_activity" | "-last_activity"
 *  - assigned_to: "me" | user_id (staff only)
 *  - unassigned: "1" (staff only)
 * @returns list of all tickets
 */
export const get_tickets_list = (params = {}) => {
  return instance.get("/v1/tickets/", { params });
};

/**
 * @param {number} ticket_id id of ticket which want to fetch details
 * @returns ticket details
 */
export const get_ticket = (ticket_id) => {
  return instance.get(`/v1/tickets/${ticket_id}/`);
};

/**
 * @param {number} ticket_id id of ticket which want to reply
 * @param {object|FormData} data message + attachment (+ is_internal/client_request_id)
 * @returns reply send
 */
export const reply_ticket = (ticket_id, data) => {
  return instance.post(`/v1/tickets/${ticket_id}/`, data);
};

/**
 * ✅ Close ticket
 * - POST /v1/tickets/{id}/close/
 */
export const close_ticket = (ticket_id) => {
  return instance.post(`/v1/tickets/${ticket_id}/close/`);
};

/**
 * ✅ Phase 9: Claim ticket (staff)
 * POST /v1/tickets/{id}/claim/
 */
export const claim_ticket = (ticket_id) => {
  return instance.post(`/v1/tickets/${ticket_id}/claim/`);
};

/**
 * ✅ Phase 9: Assign ticket (staff)
 * POST /v1/tickets/{id}/assign/
 * body: { assigned_to_id: number|null }
 */
export const assign_ticket = (ticket_id, assigned_to_id) => {
  return instance.post(`/v1/tickets/${ticket_id}/assign/`, { assigned_to_id });
};

/**
 * ✅ Phase 13: Get assignees for a unitary (staff)
 * GET /v1/tickets/assignees/?unitary=support
 */
export const get_ticket_assignees = (unitary) => {
  return instance.get("/v1/tickets/assignees/", {
    params: { unitary },
  });
};

/**
 * ✅ Phase 15: Get ticket history (staff, owner, superuser)
 * GET /v1/tickets/{ticket_id}/history/
 */
export const get_ticket_history = (ticket_id, params = {}) => {
  return instance.get(`/v1/tickets/${ticket_id}/history/`, { params });
};
